import PopupBase from './PopupBase';
import { useState, useEffect } from 'react';
import SlotApi from '../api/SlotApi';
import { Calandar } from '../common/Calandar';

const UserAddSlotPop = ({ close, userData }) => {
    const [form, setForm] = useState({
        USER_ID: userData?.USER_ID || '',
        SLOT_QUANTITY: '',
        WORK_DAYS: '',
        START_DATE: new Date().toISOString().split('T')[0],
        END_DATE: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        setForm(prev => {
            const newForm = { ...prev, [name]: value };
            
            // 작업 시작일과 슬롯 일수가 변경되면 종료일 자동 계산
            if (name === 'START_DATE' || name === 'WORK_DAYS') {
                if (newForm.START_DATE && newForm.WORK_DAYS && newForm.WORK_DAYS > 0) {
                    const startDate = new Date(newForm.START_DATE);
                    const endDate = new Date(startDate);
                    endDate.setDate(startDate.getDate() + parseInt(newForm.WORK_DAYS) - 1);
                    
                    // YYYY-MM-DD 형식으로 변환
                    const endDateStr = endDate.toISOString().split('T')[0];
                    newForm.END_DATE = endDateStr;
                } else {
                    newForm.END_DATE = '';
                }
            }
            
            return newForm;
        });
    }

    const handleConfirm = () => {
        SlotApi.addSlot(form).then(rslt => {
            console.log(rslt);
            close(true);
        });
    }

    // userData가 변경되면 form 업데이트
    useEffect(() => {
        if (userData) {
            setForm(prev => ({
                ...prev,
                USER_ID: userData.USER_ID
            }));
        }
    }, [userData]);

    return (
        <PopupBase title="슬롯 추가" confirmText="추가" cancelText="취소" confirm={handleConfirm} close={close}>    
            <div className="modal-body">
                <div className="form-field">
                    <label className="field-lable">사용자 아이디</label>
                    <div className="field-input">
                        <span className="field-required">*</span>
                        <input 
                            type="text" 
                            name="USER_ID" 
                            value={form.USER_ID}
                            readOnly 
                            onChange={handleChange} 
                        />
                    </div>      
                </div>
                <div className="form-field">
                    <label className="field-lable">슬롯 수량</label>
                    <div className="field-input">
                        <span className="field-required">*</span>
                        <input 
                            type="number" 
                            name="SLOT_QUANTITY" 
                            placeholder="추가할 슬롯 수량을 입력해주세요." 
                            required="" 
                            onChange={handleChange}
                            min="1"
                        />
                    </div>      
                </div>  
                <div className="form-field">
                    <label className="field-lable">슬롯 일수</label>
                    <div className="field-input">
                        <span className="field-required">*</span>
                        <input 
                            type="number" 
                            name="WORK_DAYS" 
                            placeholder="슬롯 사용 일수를 입력해주세요." 
                            required="" 
                            onChange={handleChange}
                            min="1"
                        />
                    </div>          
                </div>
                <div className="form-field">
                    <label className="field-lable">작업 시작일</label>
                    <div className="field-input">
                        <span className="field-required">*</span>
                        <Calandar 
                            initialDate={form.START_DATE}
                            onDateChange={(date) => {
                                const event = {
                                    target: {
                                        name: 'START_DATE',
                                        value: date
                                    }
                                };
                                handleChange(event);
                            }}
                        />
                    </div>
                </div>
                <div className="form-field">
                    <label className="field-lable">작업 종료일</label>
                    <div className="field-input">
                        <span className="field-required">*</span>
                        <input 
                            type="text" 
                            name="END_DATE" 
                            value={form.END_DATE}
                            readOnly 
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
        </PopupBase>
    )
}

export default UserAddSlotPop; 